import { useCollectiveContext } from 'context/CollectiveContext'
import ProposalsTable from '../ProposalsTable/index'
import CollectivePageHeader from '../Common/CollectivePageHeader/CollectivePageHeader'
import { useListCollectiveProposals } from 'hooks/collectives/useListCollectiveProposals'
import { useControlledInput } from 'hooks'
import { useEffect, useState } from 'react'
import { useDebouncedCallback } from 'use-debounce'
import ContentWrapper from '../../ContentWrapper'

function CollectiveProposals() {
  const { collective } = useCollectiveContext()
  const [search, setSearch] = useState<string>()
  const [searchString, onSearchStringChange, clearSearchString] =
    useControlledInput()
  const { edges, loading, loadingMore, loadMore } = useListCollectiveProposals(
    collective.id,
    10,
    search
  )
  const proposals =
    edges?.map(x => ({
      ...x.node,
      collective // inject
    })) || []
  const onSearchStringChangeDebounced = useDebouncedCallback(e => {
    setSearch(e)
  }, 300)

  useEffect(() => {
    onSearchStringChangeDebounced(searchString)
  }, [onSearchStringChange, onSearchStringChangeDebounced, searchString])

  return (
    <ContentWrapper>
      <CollectivePageHeader collective={collective} />

      <div className="p-4">
        <ProposalsTable
          title={'DAO Polls & Proposals'}
          emptyText={'No proposals yet'}
          proposals={proposals}
          onEndReached={() => loadMore()}
          loading={loading || loadingMore}
          displaySearch
          searchString={searchString}
          onSearchStringChange={onSearchStringChange}
          clearSearchString={clearSearchString}
          containerClassName={'shadow-none'}
        />
      </div>
    </ContentWrapper>
  )
}

export default CollectiveProposals
